// extracted by mini-css-extract-plugin
export default {"main":"AsideElementLearnMessage_main__kqCAp"};